import { CommonModule } from '@angular/common';
import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';

import { IonButton, IonCard, IonCardContent, IonCardHeader, IonRippleEffect } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-card',
    standalone: true,
    imports: [IonCardHeader, IonCardContent, CommonModule, IonCard, IonButton, IonRippleEffect],
    templateUrl: './card.component.html',
    styleUrl: './card.component.css'
})
export class CardComponent {
    @Input() noMargin: boolean = false;
    @Input() borders: boolean = false;
    @Input() type: 'default' | 'strong' | 'error' | 'warning' | 'success' = 'default';
    @Input() button: boolean = false;
    @Input() class: string = '';

    @Output() cardClicked: EventEmitter<void> = new EventEmitter();

    @ContentChildren(IonCardHeader) headerChildComponents?: QueryList<IonCardHeader>;

    onButtonClick() {
        this.cardClicked.emit();
    }
}
